var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-sheet',{staticClass:"mt-2",attrs:{"outlined":""}},[_c('v-expansion-panels',{attrs:{"dense":""}},[_c('v-expansion-panel',{attrs:{"dense":""}},[_c('v-expansion-panel-header',[_vm._t("title")],2),_c('v-expansion-panel-content',{attrs:{"dense":""}},[_c('v-list-item',[_c('v-list-item-content',[_c('div',[_vm._t("body")],2)])],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }